import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-upload-text" }, "Upload")
], -1)
const _hoisted_2 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 个人 ")
const _hoisted_4 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 无课题组 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("单位名称更名或错误")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("换工作单位")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 换工作单位的情况下，请重新申请账户 ")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { style: {"padding-bottom":"10px"} }, "请上传营业执照或者更名证明", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_upload = _resolveComponent("upload")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_modal, {
      visible: _ctx.visibleInfo,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => (_ctx.visibleInfo = $event)),
      title: "基本信息",
      "confirm-loading": _ctx.confirmLoadingInfo,
      destroyOnClose: true,
      maskClosable: false,
      okText: '保存',
      onCancel: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleCancel('info'))),
      onOk: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleOk('info')))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          ref: "formRefInfo",
          model: _ctx.formInfo,
          "label-col": { span: 6 },
          autocomplete: "off",
          rules: _ctx.rules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "上传头像：",
              name: "head_image"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_upload, {
                  "file-list": _ctx.fileList,
                  "onUpdate:file-list": _cache[0] || (_cache[0] = ($event: any) => (_ctx.fileList = $event)),
                  accept: ".png,.jpg",
                  "list-type": "picture-card",
                  "max-count": 1,
                  customRequest: _ctx.customRequest
                }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                }, 8, ["file-list", "customRequest"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "姓名：",
              name: "fullname"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formInfo.fullname,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formInfo.fullname = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "邮箱：",
              name: "email"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formInfo.email,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formInfo.email = $event)),
                  disabled: ""
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "手机号：",
              name: "tel"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formInfo.tel,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formInfo.tel = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "单位(开票单位)：",
              name: "company_invoice"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_a_input, {
                    value: _ctx.formInfo.company_invoice,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formInfo.company_invoice = $event)),
                    disabled: _ctx.noCompany,
                    style: {"flex":"1"}
                  }, null, 8, ["value", "disabled"]),
                  _createVNode(_component_a_checkbox, {
                    checked: _ctx.noCompany,
                    "onUpdate:checked": _cache[5] || (_cache[5] = ($event: any) => (_ctx.noCompany = $event)),
                    style: {"margin-left":"10px","white-space":"nowrap"},
                    onChange: _ctx.handleNoCompanyChange
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }, 8, ["checked", "onChange"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "课题组/负责人：",
              name: "piname"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_a_input, {
                    value: _ctx.formInfo.piname,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formInfo.piname = $event)),
                    disabled: _ctx.noTeam,
                    style: {"flex":"1"}
                  }, null, 8, ["value", "disabled"]),
                  _createVNode(_component_a_checkbox, {
                    checked: _ctx.noTeam,
                    "onUpdate:checked": _cache[7] || (_cache[7] = ($event: any) => (_ctx.noTeam = $event)),
                    style: {"margin-left":"10px","white-space":"nowrap"},
                    onChange: _ctx.handleNoTeamChange
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }, 8, ["checked", "onChange"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "单位名称：",
              name: "company"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.formInfo.company), 1),
                _createElementVNode("span", {
                  class: "link_color",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.visibleCompany = true))
                }, "修改")
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "客户id：",
              name: "k3_code"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.formInfo.k3_code), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["visible", "confirm-loading"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.visibleCompany,
      "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => (_ctx.visibleCompany = $event)),
      title: "更改单位",
      "confirm-loading": _ctx.confirmLoadingCompany,
      destroyOnClose: true,
      maskClosable: false,
      onCancel: _cache[15] || (_cache[15] = ($event: any) => (_ctx.handleCancel('company'))),
      onOk: _cache[16] || (_cache[16] = ($event: any) => (_ctx.handleOk('company')))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          ref: "formRefCompany",
          model: _ctx.formCompany,
          "label-col": { span: 4 },
          autocomplete: "off"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "",
              name: "status"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: _ctx.formCompany.status,
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => (_ctx.formCompany.status = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: 1 }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: 2 }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            (_ctx.formCompany.status === 2)
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 0,
                  label: ""
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.formCompany.status === 1)
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 1,
                  label: "单位名称：",
                  name: "company",
                  rules: [{ required: true, message: '请输入单位名称' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: _ctx.formCompany.company,
                      "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => (_ctx.formCompany.company = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.formCompany.status === 1)
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 2,
                  label: "",
                  name: "business_license"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _hoisted_9,
                      _createVNode(_component_upload, {
                        maxCount: 1,
                        onUploadSuccess: _ctx.uploadSuccess,
                        beforeUpload: _ctx.beforeUploadFile,
                        accept: '.jpg,.pdf,.png,.gif,.jpeg',
                        tipText: '支持jpg、pdf、png、gif、jpeg,不能超过5M'
                      }, null, 8, ["onUploadSuccess", "beforeUpload", "accept"])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible", "confirm-loading"])
  ], 64))
}